module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-warp"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "fl",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', [_vm._v("请选择")]), _vm._v(" "), _c('div', {
    staticClass: "fr",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "select-warp"
  }, [_c('div', {
    staticClass: "indicator"
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.list,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263a7fd1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/select/index.vue
// module id = 81
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 14 15 16 17 18 20 21 22 24 25 26 29 31 32 33 34 35 37 38 41 42 43 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 63